import React from "react";
import MaskedInput from "react-maskedinput";
import OrderForm from "./OrderForm";
import Xhr from "../../../../helpers/Xhr";

class ByBankForm extends OrderForm {
	static defaultProps = {
		minAmount : 10
	};

	state = {
		amount   : 10,
		toPay    : 9.60,
		nalog    : 0.40,
		iban     : '',
		phone    : '',
		messages : '',
	};

	onSubmit() {
		const {bank, office, type} = this.props;
		const data = {
			amount     : this.state.amount,
			bank       : 1,
			mfo        : office.mfo,
			unn        : office.unn,
			account    : this.state.iban,
			type       : type.id,
			numberMail : this.state.phone,
			bankId     : bank.id
		};

		if ( !this.hasErrors ) {
			Xhr.bankOut(data).then((resp) => {
				this.setState({
					messages : resp.messages
				});
			});
		}
	}

	render() {
		const {bank, office, type, changeOffice, changeType} = this.props;
		const requiredText = 'Поле обязательно для заполнения!';

		return (
			<div className="description__order">
				<div className="description__order-item">
					<div>
					</div>
					<div className="bank-data">
						<div className="bank-data__img">
							<img src={require(`./../../../../../assets/images/${bank.img}`)} alt={bank.name}/>
						</div>
						<div>
							<div><strong>{bank.name}</strong></div>
							<div className="comission">
								{bank.commission ? 'Банк взимает комиссию согласно своих тарифов' : 'Maxline оплачивает комиссию за Вас'}
							</div>
						</div>
					</div>
				</div>

				{/*Сумма заказа*/}
				{this.getAmountRow()}

				{/*Сумма к выплате*/}
				{this.getToPayRow()}

				{/*Налог*/}
				{this.getNalogRow()}

				{/*Номер филиала*/}
				<div className="description__order-item">
					<div>
						<label htmlFor="filial">Номер филиала:</label>
					</div>
					<div>
						<select id="filial" onChange={changeOffice} value={office.id}>
							{bank.offices.map((office, index) =>
								<option key={index} value={office.id}>{office.name}</option>)}
						</select>
					</div>
					<div className="errors">
						{this.isEmpty(office.id) && requiredText}
					</div>
				</div>

				{/*МФО банка*/}
				<div className="description__order-item">
					<div><label>МФО банка:</label></div>
					<div><input type="text" value={office.mfo || ''} disabled readOnly/></div>
				</div>

				{/*УНН банка*/}
				<div className="description__order-item">
					<div><label>УНН банка:</label></div>
					<div><input type="text" value={office.unn || ''} disabled readOnly/></div>
				</div>

				{/*Номер счета (IBAN) в банке*/}
				<div className="description__order-item">
					<div>
						<label htmlFor="iban">
							Номер счета (IBAN) в банке:
						</label>
					</div>

					<div>
						<MaskedInput id="iban"
						             name="iban"
						             mask={`BY11${bank.ibanPrefix} #### #### #### #### ####`}
						             formatCharacters={{'A' : null}}
						             size="28"
						             onChange={this.inputChange.bind(this)}
						             value={this.state.iban}/>
					</div>

					<div className="errors">
						{this.isEmpty(this.state.iban) && requiredText}
					</div>
				</div>

				<div className="description__order-item">
					<i className="warning">
						Внимание! Выплата выигрыша возможна только на карт-счёт
						открытый на имя
						(паспортные данные) владельца игрового счёта.
					</i>
				</div>

				{/*Тип счёта*/}
				<div className="description__order-item">
					<div><label htmlFor="account_type">Тип счёта:</label></div>

					<div>
						<select id="account_type" value={type.id} onChange={changeType}>
							{bank.type.map((item) =>
								<option key={item.id} value={item.id}>{item.name}</option>)}
						</select>
					</div>
				</div>

				{/*Номер телефона*/}
				{this.getPhoneRow()}

				{this.getOrderButton()}

				{this.state.messages !== '' &&
				<div className="description__order-item">
					<div></div>
					<div className="errors">{this.state.messages}</div>
					<div></div>
				</div>}

			</div>
		);
	}
}

export default ByBankForm;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/ByBankForm.js